import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { IconButton, Button, Fade } from "@material-ui/core";
import EmailIcon from "@material-ui/icons/Email";
import TwitterIcon from "@material-ui/icons/Twitter";
import FacebookIcon from "@material-ui/icons/Facebook";
import WhatsAppIcon from "@material-ui/icons/WhatsApp";
import { useHistory } from "react-router-dom";
import { useAuth } from "../../config/AuthContext";
const useStyles = makeStyles((theme) => ({
  sharePostContainer: {
    padding: theme.spacing(1, 1),
    width: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
  },

  shareDiv: {
    width: "auto",
    padding: theme.spacing(1),
    borderRadius: "5px",
    background: "transparent",
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    "& .MuiButton-root": {
      background: theme.palette.primary.dark,
    },
    "& .MuiButton-label": {
      color: theme.palette.primary.contrastText,
    },
  },

  shareSocialMediaDiv: {
    width: "auto",
    padding: theme.spacing(1),
    borderRadius: "5px",
    background: "transparent",
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    "& .MuiButton-root": {
      color: theme.palette.primary.contrastText,
    },

    "& .MuiIconButton-root": {
      color: theme.palette.text.secondary,
    },
  },
}));

const SharePost = ({ blogKey }) => {
  const classes = useStyles();
  const { dbRef } = useAuth();
  const { location } = useHistory();
  const [title, setTitle] = useState("");
  const [showFallbackShare, setShowFallbackShare] = useState(false);

  useEffect(() => {
    const unsubscribe = dbRef
      .child(`blogs/${blogKey}`)
      .once("value", async (snapshot) => {
        const snap = await snapshot.val();
        setTitle(snap.BlogTitle);
      });
    return unsubscribe;
  }, []);
  console.log(`https://maadhyam.kaushikdev.com/#${location.pathname}`);
  const handleAppShare = (e) => {
    console.log(title);
    if (navigator.share) {
      navigator
        .share({
          title: title,
          url: `https://maadhyam.kaushikdev.com/#${location.pathname}`,
        })
        .then(() => {
          console.log("Thanks for sharing!");
        })
        .catch(console.error);
    } else {
      console.log("This browser does not support web  sharing");
      setShowFallbackShare(true);
    }
  };

  return (
    <div className={classes.sharePostContainer}>
      <div className={classes.shareDiv}>
        <Button variant="contained" onClick={handleAppShare} disableElevation>
          Share this post
        </Button>
      </div>
      <Fade in={showFallbackShare}>
        <div className={classes.shareSocialMediaDiv}>
          <IconButton
            href={`mailto:?subject=${title}&body=https://maadhyam.kaushikdev.com/%23${location.pathname}`}
            onClick={() => setShowFallbackShare(false)}
          >
            <EmailIcon />
          </IconButton>
          <IconButton
            href={`https://twitter.com/intent/tweet?hashtags=Maadhyam,kaushikDev,blog&text=https://maadhyam.kaushikdev.com/%23${location.pathname}`}
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => setShowFallbackShare(false)}
          >
            <TwitterIcon />
          </IconButton>
          <IconButton
            href={`https://www.facebook.com/sharer/sharer.php?u=https://maadhyam.kaushikdev.com/%23${location.pathname}&text=${title}`}
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => setShowFallbackShare(false)}
          >
            <FacebookIcon />
          </IconButton>
          <IconButton
            href={`whatsapp://send?text=https://maadhyam.kaushikdev.com/%23${location.pathname}`}
            onClick={() => setShowFallbackShare(false)}
          >
            <WhatsAppIcon />
          </IconButton>
        </div>
      </Fade>
    </div>
  );
};

export default SharePost;
